import React, { useEffect, useState } from "react";
import {
    FormGroup,
    Form,

    InputGroup,
    Row,
    Col,
    Button,
    Card,
    CardHeader
} from "reactstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { post, get } from "../../utils/apiManager";
import { toast } from "react-toastify";
import { baseURL } from "../../config/config";



const Edit = () => {
    const { register, handleSubmit, watch, formState: { errors }, setValue } = useForm();
    const Navigate = useNavigate()
    const location = useLocation()


    useEffect(() => {
        if (location?.search) {
            getOneNewsletter(location?.search?.split("?")[1])
        }
    }, [])


    const getOneNewsletter = (id) => {
        get(`/news-letter/one/${id}`).then((res) => {
            if (res?.datas) {
                setValue("email", res?.datas?.email)
            }

        }).catch((error) => {
            console.log(error, "erre");
        })
    }



    const onSubmit = (data) => {

        const Url = `${baseURL}/news-letter/edit`



        post(Url, { email: data?.email, id: location?.search?.split("?")[1] }).then((data) => {
            if (data?.status) {
                // toast.success(data?.message);
                Navigate("/admin/news-letter")
            }
            else {
                toast.error(data?.message)
            }
        }).catch(err => {
            toast.error(err.response.data.error)

        })

    }



    return (
        <>

            <Row className="mt-7" >
                <Col className="mb-5 mb-xl-0 ml-5" xl="11" >
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <div className="d-flex">
                                <h2 style={{ textAlign: "left", marginTop: "10px" }}>Newsletter Edit</h2>

                                <Button className='bi-trash justify-content-right' style={{
                                    position
                                        : "absolute", right: 0, marginRight: "40px"
                                }} onClick={() => Navigate(`/admin/news-letter`)} color="primary">Back</Button>
                            </div>
                            <Form className="" style={{ marginTop: "40px" }} onSubmit={handleSubmit(onSubmit)}>
                                <Row>


                                    <Col md="4">
                                        <FormGroup className="mb-3">
                                            <label className="d-flex">Email <span className="text-danger">*</span></label>

                                            <InputGroup className="input-group-alternative">


                                                <input
                                                    placeholder="Email"
                                                    type="text"
                                                    {...register("email", { required: true })}
                                                    className="form-control border"
                                                />

                                            </InputGroup>
                                            {errors.email && <span className="text-danger d-flex"> This field is required</span>}
                                        </FormGroup>
                                    </Col>



                                </Row>

                                <Button color="primary" type="submit" className="d-flex" style={{ marginTop: "10px" }} >
                                    Submit
                                </Button>

                            </Form>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default Edit;